module.exports = __webpack_public_path__ + "static/media/bathroomSink90.2dec5e60.png";